(function () {
  var d = document;

  /* Apparition au défilement */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  function scan() {
    d.querySelectorAll('.dj-reveal:not(.is-in)').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
  }
  scan();
  new MutationObserver(scan).observe(d.documentElement, { childList: true, subtree: true });

  /* Pastilles couleur des cartes */
  function swap(dot) {
    var card = dot.closest('.dj-card');
    if (!card || !dot.dataset.img) return;
    var img = card.querySelector('.dj-card__img');
    if (img) { img.removeAttribute('srcset'); img.src = dot.dataset.img; }
    card.querySelectorAll('.dj-dot.is-active').forEach(function (x) { x.classList.remove('is-active'); });
    dot.classList.add('is-active');
  }
  d.addEventListener('click', function (e) { var x = e.target.closest('.dj-dot'); if (x) swap(x); });
  d.addEventListener('pointerover', function (e) { var x = e.target.closest('.dj-dot'); if (x && e.pointerType === 'mouse') swap(x); });

  /* Bannière à plusieurs produits (motion design : entrée/sortie orientées, parallaxe légère, pause hors écran) */
  function hero(el) {
    if (el.__dj) return; el.__dj = 1;
    var slides = [].slice.call(el.querySelectorAll('.dj-slide'));
    var dots = [].slice.call(el.querySelectorAll('.dj-hero__dot'));
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* La première diapositive joue son entrée dès l'arrivée sur la page */
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-ready'); }); });
    if (slides.length < 2) return;
    var i = 0, t, ms = (parseFloat(el.dataset.interval) || 6) * 1000, visible = true;
    function go(n) {
      var prev = slides[i];
      prev.classList.remove('is-active'); prev.classList.add('is-leaving'); dots[i].classList.remove('is-active');
      setTimeout(function () { prev.classList.remove('is-leaving'); }, 1000);
      i = (n + slides.length) % slides.length;
      slides[i].classList.remove('is-leaving');
      slides[i].classList.add('is-active'); dots[i].classList.add('is-active');
    }
    function stop() { clearInterval(t); }
    function play() { stop(); if (el.dataset.autoplay === 'true' && !still && visible && !d.hidden) t = setInterval(function () { go(i + 1); }, ms); }
    dots.forEach(function (b, k) { b.addEventListener('click', function () { if (k !== i) go(k); play(); }); });
    el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', play);
    el.addEventListener('focusin', stop); el.addEventListener('focusout', play);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 !== null) { var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); }
      x0 = null; play();
    });
    /* Parallaxe douce du produit qui suit la souris (ordinateur uniquement) */
    if (!still && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var raf = 0;
      el.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = el.getBoundingClientRect(), m = slides[i].querySelector('.dj-slide__media');
          if (!m) return;
          m.style.setProperty('--dj-px', (((e.clientX - r.left) / r.width - 0.5) * 22).toFixed(1) + 'px');
          m.style.setProperty('--dj-py', (((e.clientY - r.top) / r.height - 0.5) * 14).toFixed(1) + 'px');
        });
      });
      el.addEventListener('pointerleave', function () {
        slides.forEach(function (s) { var m = s.querySelector('.dj-slide__media'); if (m) { m.style.removeProperty('--dj-px'); m.style.removeProperty('--dj-py'); } });
      });
    }
    /* Pause quand l'en-tête n'est plus visible ou que l'onglet est en arrière-plan */
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? play() : stop(); }, { threshold: 0.2 }).observe(el);
    d.addEventListener('visibilitychange', function () { d.hidden ? stop() : play(); });
    play();
  }
  function initHeroes() { d.querySelectorAll('[data-dj-hero]').forEach(hero); }
  initHeroes();
  new MutationObserver(initHeroes).observe(d.documentElement, { childList: true, subtree: true });

  /* Onglets fiche produit */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.dj-tabs__btn'); if (!b) return;
    var wrap = b.closest('[data-dj-tabs]');
    wrap.querySelectorAll('.dj-tabs__btn').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
    wrap.querySelectorAll('.dj-tabs__panel').forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
  });
})();
